import { render, staticRenderFns } from "./logisTotalList.vue?vue&type=template&id=1bfe5c67&scoped=true"
import script from "./logisTotalList.vue?vue&type=script&lang=js"
export * from "./logisTotalList.vue?vue&type=script&lang=js"
import style0 from "./logisTotalList.vue?vue&type=style&index=0&id=1bfe5c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe5c67",
  null
  
)

export default component.exports